import type { User } from '#auth-utils'
import type { PendoUser } from '#shared/pendo'
import { isInternalEmail } from '#shared/utils/email'

export function buildPendoUser(
  user: User,
  env: string,
  hashedEmail: string,
  frontendVersion?: string,
): PendoUser {
  return {
    visitor: {
      id: `${env}-${hashedEmail}`,
      loggedIn: true,
      role: user.role?.[0] || 'unknown',
      source: user.source || 'unknown',
      hasLicense: !!user.licenses?.length,
      licenseModel: user.licenses?.[0]?.licenseModel || 'unknown',
      isInternal: isInternalEmail(user.email),
      ...(frontendVersion ? { frontendVersion } : {}),
    },
    account: {
      id: user.activeOrganization?.number || 'unknown',
      name: user.activeOrganization?.name || 'unknown',
    },
  }
}
